import React, { useContext, useState } from 'react';
import moment from 'moment';
import styled from 'styled-components';
import media, { sizes } from 'src/styles/Media.styled';
import Note from 'src/assets/images/Note.svg';
import NoteDark from 'src/assets/images/NoteDark.svg';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import {
    MainTitleComponent,
    VerticalDetailViewTop,
    SmallViewFlex,
    ParentContainer,
    TitleComponent,
    SurgeryDiv,
    BackIconContainer,
    BackIcon,
    BackIconNotes,
    StyledSurgerySpan,
    LineSeparator,
    Title,
    SurgeryNoteBack,
    IconPlaceHolder,
    CountContainer,
    Icon,
    LabelCount,
} from './ReportUsageHeader.styled';
import ArrowLeft from 'src/assets/images/ArrowLeftBack.svg';
import DownArrow from 'src/assets/images/DownArrowFilter.svg';
import ReportUsageSubHeader from 'src/pages/reportUsage/header/ReportUsageSubHeader.jsx';
import { ReportUsageContext } from 'src/pages/reportUsage';
import UnidPlanPdfNotAvailable from 'src/pages/scheduleSurgery/components/surgery/notifications/UnidPlanPdfNotAvailable';
import AiblePlanPdfNotAvailable from 'src/pages/scheduleSurgery/components/surgery/notifications/AiblePlanPdfNotAvailable';
import { getDisplayDateTime } from 'src/utils/dateUtils';
import ArrowLeftLight from 'src/assets/images/ArrowLeftLight.svg';
import { logErrorToConsole } from 'src/utils/util';

const ReportUsageHeader = ({
    isPriceOverride,
    shipAddress,
    showReportPayment,
    isNavigatedToReportPayment,
    selectedPhysicianData,
    backIconClickHandler,
    isNoUsageToReport,
    cancelSurgeryData,
    setViewSurgeryNotes,
    viewSurgeryNotes,
    noteCount,
}) => {
    const usageDetails = isNoUsageToReport
        ? cancelSurgeryData
        : useContext(ReportUsageContext)?.usageDetails;
    const dateOfSurgery = usageDetails?.surgeryDate;
    const [pdfNotAvailable, setPdfNotAvailable] = useState(false);
    const getBrowserTimeZoneName = () => {
        return moment.tz
            .zone(moment.tz.guess())
            .abbr(new Date().getTimezoneOffset());
    };
    const winWidth = window.innerWidth;
    const bannerHeight = useSelector(
        (state) => state.loginReducer.bannerHeight
    );

    const usageOrderSubmission = useSelector(
        (state) => state.reportUsageRootReducer.usageOrderSubmission
    );
    const isSubmitClicked = useSelector(
        (state) => state.reportUsageRootReducer.isSubmitClicked
    );

    const orderStatus = useSelector(
        (state) => state.reportUsageRootReducer.orderStatus
    );

    const isUsagedSubmittedSuccessfully =
        (usageOrderSubmission && usageOrderSubmission.statusCode === '200') ||
        (Object.keys(orderStatus).length > 0 &&
            orderStatus.status &&
            orderStatus.status.includes('Usage Order Submitted Successfully'));

    // Added for testing purpose
    // const unidUrl =
    //     '*#*https://med-hub-us-staging.s3.amazonaws.com/documents/09082021_98aafc06-93ad-4f85-b303-911c8dde5e33.pdf?AWSAccessKeyId=AKIAI5NAAA3ZJ7J4I33A&amp;Expires=1633000896&amp;Signature=9v515IbiCS9yzktMq3gJRaA1B8M%3D*#*https://med-hub-us-staging.s3.amazonaws.com/documents/17082021_9f7c4f79-8a7b-4b7f-ab9b-95b0b3010eeb.pdf?AWSAccessKeyId=AKIAI5NAAA3ZJ7J4I33A&amp;Expires=1633000896&amp;Signature=FSwQnFve5lHTV%2BYbCGlrkryfkjE%3D';

    const openUNIDLinks = () => {
        const { unidIdURL } = usageDetails;
        if (unidIdURL === 'EmptyUrl' || !unidIdURL) {
            setPdfNotAvailable(true);
        } else {
            const urls = unidIdURL.split('*#*').filter((url) => url);
            urls.forEach((url) => {
                window.open(url);
            });
        }
    };

    const { t } = useTranslation();
    const { isLanguageChanged } = useSelector((state) => state.loginReducer);
    return (
        <>
            <ParentContainer paddingBottom={'20px'} smFlexWrap = {showReportPayment && 'wrap'} smGap = {showReportPayment && '10px'} mdFlexDirection = {'column'}>
                <SmallViewFlex
                    bannerMargin={bannerHeight}
                    lg={4}
                    md={4}
                    shipAddress={shipAddress}
                    mdFlexRatio={'1 1 30%'}
                    smFlexRatio={'100%'}
                    mdWidth={'100%'}
                    mdViewSurgeryFlexRatio = {'100%'}
                    isPriceOverride = {isPriceOverride}
                >
                    {((!isNavigatedToReportPayment && showReportPayment) ||
                        isPriceOverride) && (<BackIconContainer isReportPayment={showReportPayment}>
                            <BackIcon
                                id={`back-icon-${usageDetails?.myCaseRef || 'default'}`}
                                src={
                                    window.innerWidth <= sizes.mobileDevice
                                        ? ArrowLeft
                                        : DownArrow
                                }
                                alt={'backIcon'}
                                onClick={backIconClickHandler}
                            />
                        </BackIconContainer>) ||
                        (viewSurgeryNotes && (
                            // <BackIconContainer
                            //     isReportPayment={showReportPayment}
                            // >
                            //     {/* <BackIcon
                            //         src={
                            //             window.innerWidth <= sizes.mobileDevice
                            //                 ? ArrowLeft
                            //                 : DownArrow
                            //         }
                            //         alt={'backIcon'}
                            //         onClick={backIconClickHandler}
                            //     /> */}
                            //     <div style={{ display: 'flex' }}>
                            //         <BackIconNotes>
                            //             <img
                            //                 src={ArrowLeftLight}
                            //                 onClick={() =>
                            //                     setViewSurgeryNotes(false)
                            //                 }
                            //                 style={{
                            //                     cursor: 'pointer',
                            //                 }}
                            //             ></img>
                            //         </BackIconNotes>
                            //         <SurgeryNoteBack
                            //             onClick={() =>
                            //                 setViewSurgeryNotes(false)
                            //             }
                            //         >
                            //             Back
                            //         </SurgeryNoteBack>
                            //     </div>
                            // </BackIconContainer>
                            <Title viewSurgeryNotes mdFlex={viewSurgeryNotes && '2'}>
                                {window.innerWidth > sizes.mobileDevice ? <div className="mobile">
                                    {t('reportUsage.customerCareNotes')}
                                </div>:
                                <div className="mobile" style={{paddingLeft:'15px'}}>
                                {showReportPayment ? 
                                    t('procedure.reportPaymentTitle') : t('reportUsage.title')}
                            </div>}

                                <div className="web" style={{ marginRight: isLanguageChanged ? '7%' : '0%' }}>
                                    {viewSurgeryNotes ? (
                                        <div style={{ display: 'flex' }}>
                                            <BackIconNotes>
                                                <img
                                                    id={`back-icon-img-${usageDetails?.myCaseRef || 'default'}`}
                                                    src={ArrowLeftLight}
                                                    onClick={() =>
                                                        setViewSurgeryNotes(
                                                            false
                                                        )
                                                    }
                                                    style={{
                                                        cursor: 'pointer',
                                                    }}
                                                ></img>
                                            </BackIconNotes>
                                            <SurgeryNoteBack
                                                id={`surgery-note-back-${usageDetails?.myCaseRef || 'default'}`}
                                                onClick={() =>
                                                    setViewSurgeryNotes(false)
                                                }
                                            >
                                                {t(
                                                    'reportUsage.replen.selectShipToAddress.backText'
                                                )}
                                            </SurgeryNoteBack>
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                    {viewSurgeryNotes 
                                        ? t('reportUsage.customerCareNotes')
                                        : ''}
                                </div>
                            </Title>
                        ))
                        }

                    {!viewSurgeryNotes && (
                        <>
                            <MainTitleComponent
                                isPriceOverride = {isPriceOverride}
                                isBackIconVisible={
                                    (!isNavigatedToReportPayment &&
                                        showReportPayment) ||
                                    isPriceOverride ||
                                    viewSurgeryNotes
                                }
                                flexRatio={
                                    showReportPayment &&
                                    window.innerWidth > sizes.mobileDevice &&
                                    0.6
                                }
                                mbReportPaymentPaddingLeft={'2px'}
                                iPhoneMiniFontSize={showReportPayment && '21px'}
                            >
                                {isPriceOverride ? (
                                    t('reportUsage.record.priceOverride.title')
                                ) : showReportPayment ? (
                                    t('procedure.reportPaymentTitle')
                                ) : viewSurgeryNotes ? (
                                    t('reportUsage.customerCareNotes')
                                ) : window.innerWidth <= sizes.mobileDevice ? (
                                    <div>
                                        {t('reportUsage.title')}
                                        <br />
                                        <div style={{ marginTop: '-9px' }}>
                                            <TitleComponent mdMarginLeft={'0'}>
                                                {usageDetails?.myCaseRef} {' '}
                                                {showReportPayment && 
                                                winWidth <= sizes.mobileDevice
                                                    ? ''
                                                    : t(
                                                          'orders.orderListFilterDropDown.surgery.categoryName'
                                                      ) + ':'} {' '}
                                                <StyledSurgerySpan paddingLeft="0px">
                                                    {getDisplayDateTime(
                                                        dateOfSurgery
                                                    )}{' '}
                                                    {showReportPayment
                                                        ? 'EDT'
                                                        : getBrowserTimeZoneName()}
                                                </StyledSurgerySpan>
                                            </TitleComponent>
                                            {/* <SurgeryDiv mdMarginLeft={'0'}>
                                                {showReportPayment &&
                                                winWidth <= sizes.mobileDevice
                                                    ? ''
                                                    : 'Surgery:'}{' '}
                                                <StyledSurgerySpan>
                                                    {getDisplayDateTime(
                                                        dateOfSurgery
                                                    )}{' '}
                                                    {showReportPayment
                                                        ? 'EDT'
                                                        : getBrowserTimeZoneName()}
                                                </StyledSurgerySpan>
                                            </SurgeryDiv> */}
                                        </div>
                                    </div>
                                ) : (
                                    t('reportUsage.title')
                                )}
                            </MainTitleComponent>
                        </>
                    )}

                    {
                    usageDetails  ? (
                        <>
                        { !viewSurgeryNotes &&  window.innerWidth > sizes.mobileDevice?<VerticalDetailViewTop
                            flexRatio={
                                isPriceOverride &&
                                window.innerWidth > sizes.smalDevice &&
                                1
                            }
                            lgFlexRatio={usageDetails.hrefId?'0.8':''}
                            mbPaddingRight={
                                showReportPayment || isPriceOverride
                                    ? '10px'
                                    : '15px'
                            }
                            iPhoneMiniPaddingRight={
                                showReportPayment
                                    ? '10px'
                                    : isPriceOverride && '10px'
                            }
                            mbFlexRatio={showReportPayment ? '0.55' : '0.6'}
                            iPhoneMiniFlexRatio={showReportPayment && '0.6'}
                            marginRight={usageDetails.hrefId ? 
                                (window.innerWidth>sizes.mobileDevice &&
                                    window.innerWidth<=sizes.smalDevice) ?
                                        '5px'
                                        : '50px' :'0'}
                        >
                            <TitleComponent mdMarginLeft={'0'}>
                                {usageDetails?.myCaseRef}
                            </TitleComponent>
                             
                            <SurgeryDiv mdMarginLeft={'0'}>
                                {showReportPayment &&
                                winWidth <= sizes.mobileDevice
                                    ? ''
                                    : `${t(
                                          'orders.orderListFilterDropDown.surgery.categoryName'
                                      )}:`}{' '}
                                <StyledSurgerySpan 
                                paddingLeft="0px">
                                    {getDisplayDateTime(dateOfSurgery)}{' '}
                                    {showReportPayment
                                        ? 'EDT'
                                        : getBrowserTimeZoneName()}
                                </StyledSurgerySpan>
                            </SurgeryDiv>
                          
                             
                      </VerticalDetailViewTop>:null}
                        { (window.innerWidth <= sizes.mediumDevice) && 
                            !isUsagedSubmittedSuccessfully &&
                            !isSubmitClicked &&
                            !isPriceOverride ? (
                                <IconPlaceHolder
                                    id={`icon-placeholder-${usageDetails?.myCaseRef || 'default'}`}
                                    margin={'7px 0px 0px 4px'}
                                    onClick={() => {
                                        try {
                                        setViewSurgeryNotes(true);
                                        // dispatch(isNotesVisited(true));
                                        
                                        // Scroll to top when notes open to ensure header is visible
                                        setTimeout(() => {
                                            window.scrollTo(0, 0);
                                        }, 150);
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                    mdFlex={viewSurgeryNotes && '1'}
                                    mdDisplay = {viewSurgeryNotes && 'flex'}
                                    mdjustifyContent = {viewSurgeryNotes && 'flex-end'}
                                >
                                    <Icon
                                    id="report-usage-header-icon"
                                        deskPath={NoteDark}
                                        mobilePath={Note}
                                        bottom={viewSurgeryNotes && window.innerWidth > sizes.mobileDevice ? '-4px' : '4px'}
                                    >
                                        {noteCount > 0 && (
                                            <CountContainer
                                                colorNote={false}
                                                backgroundColor={'12c8f7'}
                                                desktopBorder={
                                                    '1px solid #140F4B'
                                                }
                                                border={'1px solid #140F4B'}
                                                width={
                                                    noteCount > 0 &&
                                                    noteCount <= 9
                                                        ? '18px'
                                                        : noteCount >= 10 &&
                                                          noteCount <= 99
                                                        ? '25px'
                                                        : '27px'
                                                }
                                                height={
                                                    noteCount > 0 &&
                                                    noteCount <= 9
                                                        ? '18px'
                                                        : noteCount >= 10 &&
                                                          noteCount <= 99
                                                        ? '24px'
                                                        : '27px'
                                                }
                                                right={
                                                    noteCount > 0 &&
                                                    noteCount <= 9
                                                        ? '3px'
                                                        : noteCount >= 10 &&
                                                          noteCount <= 99
                                                        ? '2px'
                                                        : '2px'
                                                }
                                                top={
                                                    noteCount > 0 &&
                                                    noteCount <= 9
                                                        ? '-4px'
                                                        : noteCount >= 10 &&
                                                          noteCount <= 99
                                                        ? '-9px'
                                                        : '-12px'
                                                }
                                                mbRight={
                                                    noteCount > 0 &&
                                                    noteCount <= 9
                                                        ? '4px'
                                                        : '2px'
                                                }
                                                mbTop={
                                                    noteCount > 0 &&
                                                    noteCount <= 9
                                                        ? '-4px'
                                                        : '-9px'
                                                }
                                            >
                                                <LabelCount colorNote={false}>
                                                    {noteCount}
                                                </LabelCount>
                                            </CountContainer>
                                        )}
                                    </Icon>
                                </IconPlaceHolder>
                            ) : null}
                        </>
                    ) : !viewSurgeryNotes &&
                      usageDetails &&
                      window.innerWidth <= sizes.mobileDevice ? (
                        <VerticalDetailViewTop
                            flexRatio={
                                isPriceOverride &&
                                window.innerWidth > sizes.smalDevice &&
                                1
                            }
                            mbPaddingRight={
                                showReportPayment || isPriceOverride
                                    ? '10px'
                                    : '15px'
                            }
                            iPhoneMiniPaddingRight={
                                showReportPayment
                                    ? '10px'
                                    : isPriceOverride && '10px'
                            }
                            mbFlexRatio={showReportPayment ? '0.55' : '0.6'}
                            iPhoneMiniFlexRatio={showReportPayment && '0.6'}
                        >
                            {!isUsagedSubmittedSuccessfully &&
                            !isSubmitClicked &&
                            !isPriceOverride ? (
                                <IconPlaceHolder
                                    id={`icon-placeholder-${usageDetails?.myCaseRef || 'default'}`}
                                    margin={'0px 5px 0px 0px'}
                                    onClick={() => {
                                        try {
                                        setViewSurgeryNotes(true);
                                        // dispatch(isNotesVisited(true));
                                        
                                        // Scroll to top when notes open to ensure header is visible
                                        setTimeout(() => {
                                            window.scrollTo(0, 0);
                                        }, 150);
                                        } catch (error) {
                                            logErrorToConsole(error);
                                        }
                                    }}
                                >
                                    <Icon
                                    id="report-usage-header-icon"
                                        deskPath={NoteDark}
                                        mobilePath={Note}
                                        bottom={'-4px'}
                                    >
                                        {noteCount > 0 && (
                                            <CountContainer
                                                colorNote={false}
                                                backgroundColor={'12c8f7'}
                                                desktopBorder={
                                                    '1px solid #140F4B'
                                                }
                                                border={'1px solid #140F4B'}
                                                width={
                                                    noteCount > 0 &&
                                                    noteCount <= 9
                                                        ? '18px'
                                                        : noteCount >= 10 &&
                                                          noteCount <= 99
                                                        ? '25px'
                                                        : '27px'
                                                }
                                                height={
                                                    noteCount > 0 &&
                                                    noteCount <= 9
                                                        ? '18px'
                                                        : noteCount >= 10 &&
                                                          noteCount <= 99
                                                        ? '24px'
                                                        : '27px'
                                                }
                                                right={
                                                    noteCount > 0 &&
                                                    noteCount <= 9
                                                        ? '3px'
                                                        : noteCount >= 10 &&
                                                          noteCount <= 99
                                                        ? '2px'
                                                        : '2px'
                                                }
                                                top={
                                                    noteCount > 0 &&
                                                    noteCount <= 9
                                                        ? '-4px'
                                                        : noteCount >= 10 &&
                                                          noteCount <= 99
                                                        ? '-9px'
                                                        : '-12px'
                                                }
                                                mbRight={
                                                    noteCount > 0 &&
                                                    noteCount <= 9
                                                        ? '4px'
                                                        : '2px'
                                                }
                                                mbTop={
                                                    noteCount > 0 &&
                                                    noteCount <= 9
                                                        ? '-4px'
                                                        : '-9px'
                                                }
                                            >
                                                <LabelCount colorNote={false}>
                                                    {noteCount}
                                                </LabelCount>
                                            </CountContainer>
                                        )}
                                    </Icon>
                                </IconPlaceHolder>
                            ) : null}
                        </VerticalDetailViewTop>
                    ) : null}
                </SmallViewFlex>
                {!isPriceOverride ? (
                    <MultiViewComponent
                        flexJustify={
                            viewSurgeryNotes
                                ? 'flex-end'
                                : usageDetails.hrefId
                                ? 'space-between'
                                : 'flex-end'
                        }
                        smFlexJustify={'flex-start'}
                        mdFlexRatio={showReportPayment && '0.9'}
                        smFlexAlign={showReportPayment && 'flex-start'}
                    >
                        {usageDetails &&
                            Object.keys(usageDetails).length > 0 && (
                                <ReportUsageSubHeader
                                    usageDetails={usageDetails}
                                    openUNIDLinks={openUNIDLinks}
                                    selectedPhysicianData={selectedPhysicianData}
                                    isReportPayment={showReportPayment}
                                    setViewSurgeryNotes={setViewSurgeryNotes}
                                    viewSurgeryNotes={viewSurgeryNotes}
                                    noteCount={noteCount}
                                />
                            )}
                    </MultiViewComponent>
                ) : null}

                {!viewSurgeryNotes ||
                    (pdfNotAvailable &&
                        (usageDetails.vendorCaseId?.startsWith('UH_') ||
                            usageDetails.vendorCaseId?.startsWith('AH_')) && (
                            <UnidPlanPdfNotAvailable
                                onClose={() => setPdfNotAvailable(false)}
                            />
                        ))}
            </ParentContainer>
            {!viewSurgeryNotes ||
                (isPriceOverride && window.innerWidth >= sizes.largeDevice && (
                    <LineSeparator
                        borderTop={'1px solid #EBEBEB'}
                        margin={'-20px 0 0 -27vw'}
                        width={'115vw'}
                    />
                ))}
        </>
    );
};

export default ReportUsageHeader;

const MultiViewComponent = styled.div`
    flex: ${(props) => (props.flexRatio ? props.flexRatio : 1)};
    flex-direction: ${(props) => (props.fDirection ? props.fDirection : 'row')};
    display: ${(props) => (props.displayType ? props.displayType : 'flex')};
    align-items: ${(props) => (props.flexAlign ? props.flexAlign : 'center')};
    justify-content: ${(props) =>
        props.flexJustify ? props.flexJustify : 'space-between'};
    ${media.mediumDevice`
        flex: ${(props) => props.mdFlexRatio};
        align-items:flex-start;
        display: ${(props) => (props.displayType ? props.displayType : 'block')};
    `}
    ${media.smalDevice`
        flex: ${(props) => (props.flexRatio ? props.flexRatio : 1.0)};
        justify-content: ${(props) => props.smFlexJustify};
    `}

    ${media.mobileDevice`
        flex-direction: ${(props) =>
            props.fDirection ? props.fDirection : 'column'};
        display: none;
        padding-top: ${(props) =>
            props.paddingTop ? props.paddingTop : '13px'};
    `}
`;
